import 'whatwg-fetch';
import { HttpClient, json } from 'aurelia-fetch-client';
import { inject, TaskQueue } from 'aurelia-framework';
import { LoggerService } from './logger-service';
import { DialogHelperService } from './dialog-helper-service';
import { Router } from 'aurelia-router';
import { BrowserStorageService } from './browser-storage-service';
import { WebLoggerService } from './weblogger-service';

var config = require('../../../config');

@inject(
    HttpClient,
    TaskQueue,
    LoggerService,
    DialogHelperService,
    Router,
    BrowserStorageService,
    WebLoggerService
)
export class FetchService {
    constructor(
        httpClient,
        taskQueue,
        loggerService,
        dialogService,
        router,
        browserStorage,
        webLogger
    ) {
        this.httpClient = httpClient;
        this.taskQueue = taskQueue;
        this.logger = loggerService;
        this.dialogService = dialogService;
        this.router = router;
        this.browserStorage = browserStorage;
        this.webLogger = webLogger;

        this.dialogShown = false;
    }

    get(url, moduleId, ignoreError, useText) {
        let that = this;
        var auth = window.atob(this.browserStorage.getItem('authorization'));
        this.dialogShown = false;
        var fetchConfig = {
            mode: 'cors',
            credentials: 'include',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: auth
            })
        };

        // todo: remove testcode
        var test = this.browserStorage.getItem('testfetch');

        switch (test) {
            case 'invalidurl':
                if (url.endsWith('/campaigns')) {
                    url = url.replace('/campaigns', '/campaignsx');
                }
                break;
            case 'invalidurlaccessdenied':
                url = url.replace('/v1', '/v1xxx');
                break;
            case 'sessionexpired':
                fetchConfig = {
                    mode: 'cors',
                    credentials: 'include',
                    headers: new Headers({
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    })
                };
                break;
            case 'notauthorizedtothisdata':
                url = url.replace('Progress', 'Geico123').replace('HaPrDDn_', 'n7N-H1Yt');
                break;
        }
        // end testcode

        this.httpClient.configure(config => {
            config.withBaseUrl('/').rejectErrorResponses();
        });

        return Promise.all([
            this.httpClient
                .fetch(url, fetchConfig)
                .catch(error => {
                    that.logger.debug('Catch fired, error:', error);

                    if (error.status === 404) {
                        return Promise.reject(error);
                    } else {
                        if (!ignoreError) {
                            var statusCode = error.status;
                            var message = {};
                            var eventMessage = '';

                            if (error.toString().startsWith('TypeError')) {
                                // local fetch error (status codes not returned in local so everything looks like a CORS error)
                                message = that.parseStatusText(error.toString());
                                eventMessage = message.debug;
                                statusCode = 403;
                            } else {
                                // normal error path in non-local environments
                                message = that.parseStatusText(statusCode.toString());
                                eventMessage =
                                    message.debug +
                                    '. statusCode: ' +
                                    statusCode +
                                    ' statusText: ' +
                                    error.statusText;
                            }

                            that.webLogger.logEvent(
                                statusCode ? statusCode : 403,
                                eventMessage,
                                moduleId,
                                error.toString(),
                                'warning'
                            );
                            that.popLightbox(message, statusCode).then(response => {
                                this.logger.debug('popLightbox returns: ', response);
                            });

                            if (error.headers) {
                                var contentType = error.headers.get('content-type');

                                if (contentType && contentType.indexOf('application/json') !== -1) {
                                    var errorJson = error.json();
                                    return Promise.reject(errorJson);
                                } else {
                                    var errorText = error.text();
                                    return Promise.reject(errorText);
                                }
                            } else {
                                return Promise.reject(error);
                            }
                        }
                    }
                })
                .then(response => {
                    that.logger.debug('Fetch/then response:', response);

                    if (response.status == 200) {
                        // success
                        var ret = null;
                        if (useText) {
                            ret = response.text();
                        } else {
                            ret = response.json();
                        }

                        return Promise.resolve(ret);
                    }
                })
        ]);
    }

    popLightbox(message, statusCode) {
        let that = this;

        return new Promise(function (resolve, reject) {
            if (!that.dialogShown) {
                that.logger.debug('Raising http error lightbox with message:', message.debug);

                that.dialogService
                    .httpError(statusCode, message.system, that.router)
                    .then(response => {
                        that.dialogShown = false;
                        resolve(response);
                    });
            } else {
                resolve(null);
            }
        });
    }

    parseStatusText(statusText) {
        this.logger.debug('parsestatusText() called:', statusText);

        if (statusText.indexOf('TypeError') > -1) {
            // e.g., basically all local fetch errors
            return {
                user: "Sytem error - can't connect to Delty",
                system: 'localfetch',
                debug: 'JS Fetch Error'
            };
            /*
      } else if (1) {
         // since the call to parseStatusText was moved from the .then to the .catch it now doesn't 
         // get the message text to analyze the actual error, so just report the status to the user but offer 
         // for them to try logging in again.  Note: else statements below won't ever be hit, but leaving them in for future reference.
         return {
            user: 'Possible session expired error - login again',
            system: 'sessionexpired',
            debug: 'Session expired'
         };
      */
            //} else if (statusText.indexOf('Missing Key-Pair-Id query parameter or cookie value') > -1 ||
            //   statusText.indexOf('Unauthorized') > -1) {
        } else if (statusText === '401' || statusText === '403') {
            // e.g., not sending authorization token, sending expired token, or sending expired cookies
            return {
                user: 'Session expired - login again',
                system: 'sessionexpired',
                debug: 'Session expired'
            };
            // } else if (statusText.indexOf('Authorization header requires \'Credential\' parameter') > -1 ||
            //   statusText.indexOf('Authorization header must begin with the algorithm name') > -1) {
            // not hit due to glumping 403 into the session expired error above
            /*
      } else if (statusText === '403') {
         // e.g., https://int-www.delty.com/v1/advertisers/wU7HM26E/campaignsxxxxxxxx   (status code = 403)
         return {
            user: 'System error - invalid request (URL) was made',
            system: 'invalidurl',
            debug: 'Invalid URL - path'
         };
      */
            // } else if (statusText.indexOf('Endpoint request timed out') > -1) {
        } else if (statusText == '504') {
            // e.g., 504 {"message": "Endpoint request timed out"} DynamoDB read capacity exceeded
            return {
                user: 'Temporary internal data capacity error',
                system: 'internaldatacapacityerror',
                debug: 'Internal dynamodb capacity exceeded'
            };
        } else if (statusText.indexOf('<Message>Access Denied</Message>') > -1) {
            // this an xml response from S3, not JSON
            // e.g., https://int-www.delty.com/v1xxxxxxxx/advertisers/wU7HM26E/campaigns
            return {
                user: 'System error - invalid request (URL), access denied',
                system: 'invalidurlaccessdenied',
                debug: 'Invalid URL - access denied'
            };
        } else if (statusText.indexOf('User is not authorized to access this resource') > -1) {
            // e.g., having advertiser key as progressive, but passing key for allstate (status code = 403)
            return {
                user: 'Not authorized to access this data',
                system: 'notauthorizedtothisdata',
                debug: 'Not authorized to see this data'
            };
        } else {
            // undefined error
            return {
                user: 'System error - undefined',
                system: 'undefined',
                debug: 'Undefined error'
            };
        }
    }
}
